import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Navbar, Nav, NavDropdown } from "react-bootstrap";
import { NavDropdownLink } from "../Menus/DropdownLink";
import SchoolBadge from "../Badges/SchoolBadge";
import { updateAidYear } from "../../actions/GlobalActions";
import { ssoSignOut, getUser } from "../../actions/AuthActions";
import {
  getSchoolLogo,
  fetchSchoolIsirRecInfo,
} from "../../actions/SchoolActions";
import PermissionComponentCheck from "../PermissionComponents/PermissionComponentCheck";
import CrossSchoolSearchInput from "../Inputs/CrossSchoolSearchInput";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import ScreenReaderNavigator from "../Menus/ScreenReaderNavigator";

const AdminHeader = ({updateAidYear, ssoSignOut, auth, school, global, getUser, getSchoolLogo, fetchSchoolIsirRecInfo, hasStudentRepo}) => {
  const [logoLoaded, setLogoLoaded] = React.useState(false);

  useEffect(() => {
    if (!auth?.ssoUser) {
      getUser();
    }
  }, [auth, school.schoolCode, global.aidYear, auth.ssoUser, getUser]);

  useEffect(() => {
    if (school.schoolCode) {
      setLogoLoaded(true);
      getSchoolLogo(school.schoolCode);
      fetchSchoolIsirRecInfo(
        school.schoolCode,
        global.aidYear
      );
    }
  }, [school.schoolCode, global.aidYear, getSchoolLogo, fetchSchoolIsirRecInfo]);

  if (logoLoaded) {
    return (
      <div>
        <ScreenReaderNavigator />
        <Navbar id="adminHeader" bg="white" expand="md">
          <Link to="/welcome" className="navbar-brand">
            <img
              src={`data:image/jpeg;base64,${school.schoolLogo}`}
              alt={school.schoolName + "_logo"}
            ></img>
          </Link>

          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
              <NavDropdown title="SCHOOL" id="basic-nav-dropdown">
                <NavDropdownLink
                  requiredPermission="GLOBAL_SCHOOL_SETTINGS_VIEW"
                  to="/Metrics"
                  text="Metrics"
                />
                <NavDropdown.Divider />
                <p className="dropdownLabel">Manage my School</p>
                <NavDropdownLink
                  requiredPermission="GLOBAL_SCHOOL_SETTINGS_VIEW"
                  to="/GlobalSchoolSettings"
                  text="School Settings (Global)"
                />
                <NavDropdownLink
                  requiredPermission="AID_YEAR_SCHOOL_SETTINGS_VIEW"
                  to="/SchoolAidYearSettings"
                  text="School Settings (Aid Year)"
                />
                <NavDropdownLink
                  requiredPermission="MESSAGE_TEMPLATES_VIEW"
                  to="/MessageTemplates"
                  text="Message Templates"
                />
                {/* <NavDropdownLink to="/SchoolProfile" text="School Profile" /> */}
                <NavDropdownLink
                  requiredPermission="SCHOOL_ANNUAL_ROLLOVER_EDIT"
                  to="/SchoolAnnualRollover"
                  text="School Annual Rollover"
                />
                <NavDropdownLink
                  requiredPermission="ISIR_VIEW_SETTINGS_VIEW"
                  to="/IsirViewSettings"
                  text="ISIR View Settings"
                />
                <NavDropdownLink
                  requiredPermission="PERMISSIONS_VIEW"
                  to="/Permissions"
                  text="Permissions"
                />
                <NavDropdownLink
                  requiredPermission="SAIG_MAILBOX_ADMINISTRATION_VIEW"
                  to="/SAIGMailboxAdministration"
                  text="SAIG Mailbox Administration"
                />
                <NavDropdownLink
                  requiredPermission="HOLIDAYS_VIEW"
                  to="/Holidays"
                  text="Holidays"
                />
                <NavDropdownLink
                  requiredPermission="VIEW_NOTIFICATIONS_PAGE"
                  to="/Notifications"
                  text="Notifications"
                />
                <NavDropdownLink
                  requiredPermission="ADMINISTRATIVE_ACTIVITY_VIEW"
                  to="/AdministrativeActivity"
                  text="Administrative Activity"
                />
                <NavDropdownLink
                  requiredPermission="STUDENT_ACTIVITY_VIEW"
                  to="/StudentActivity"
                  text="Student Activity"
                />
                <NavDropdownLink
                  requiredPermission="SCHOOL_AUDIT_VIEW"
                  to="/SchoolAudit"
                  text="School Audit"
                />
              </NavDropdown>
              <NavDropdown title="STUDENTS" id="basic-nav-dropdown">
                <NavDropdownLink to="/userSearch" text="View Students" />
                <NavDropdownLink
                  requiredPermission="COMMUNICATION_LOG_VIEW"
                  to="/communicationLog"
                  text="Communication Log"
                />
              </NavDropdown>
              <PermissionComponentCheck
                requiredPermission="ED_DATA_VIEW"
                denyAction="hide"
              >
                <NavDropdown title="ED DATA" id="basic-nav-dropdown">
                  <p className="dropdownLabel">ISIR Management</p>

                  <NavDropdownLink
                    requiredPermission="UPLOAD_ISIR"
                    to="/upload"
                    text="Upload ISIR File"
                  />
                  <NavDropdownLink
                    requiredPermission="REVIEW_ISIR_UPLOADS"
                    to="/isirLog"
                    text="Review ISIR File Uploads"
                  />
                  <NavDropdown.Divider />
                  {hasStudentRepo && (
                    <>
                      <p className="dropdownLabel">Repository Management</p>
                      <NavDropdownLink
                        requiredPermission="STUDENT_REPOSITORY_VIEW"
                        to="/studentRepo"
                        text="Student Repository"
                      />
                      <NavDropdownLink
                        requiredPermission="STUDENT_REPOSITORY_UPLOAD_REPORT_VIEW"
                        to="/studentRepoUploadReport"
                        text="Student Repository Upload Report"
                      />
                      <NavDropdownLink
                        requiredPermission="STUDENT_REPOSITORY_ERROR_REPORT_VIEW"
                        to="/studentRepoErrorReport"
                        text="Student Repository Error Report"
                      />
                      <NavDropdown.Divider />
                    </>
                  )}

                  <p className="dropdownLabel">Corrections</p>
                  <NavDropdownLink
                    requiredPermission="CORRECTIONS_LIST_VIEW"
                    to="/corrections"
                    text="Corrections List"
                  />
                  <NavDropdownLink
                    requiredPermission="TRANSMITTED_CORRECTIONS_VIEW"
                    to="/transmittedCorrections"
                    text="Transmitted Corrections"
                  />
                  <NavDropdown.Divider />
                  <p className="dropdownLabel">SAIG</p>
                  <NavDropdownLink
                    requiredPermission="SAIG_MAILBOX_VIEW"
                    to="/saigMailbox"
                    text="SAIG Mailbox"
                  />
                </NavDropdown>
              </PermissionComponentCheck>
              <PermissionComponentCheck
                requiredPermission="REPORTS_VIEW"
                denyAction="hide"
              >
                <NavDropdown title="REPORTS" id="basic-nav-dropdown">
                  <NavDropdownLink
                    requiredPermission="GENERAL_REPORT_VIEW"
                    to="/GeneralReport"
                    text="General Report"
                  />
                  {/* <NavDropdownLink
                    requiredPermission="ALL_STUDENTS_REPORT_VIEW"
                    to="/PendingTaskListItemReport"
                    text="Pending Task List Item Report"
                  /> */}
                  <NavDropdownLink
                    requiredPermission="MISSING_STUDENT_ID_REPORT_VIEW"
                    to="/MissingStudentReport"
                    text="Missing Student ID Report"
                  />
                  <NavDropdownLink
                    requiredPermission="POSTCARDS_REPORT_VIEW"
                    to="/PostcardsReport"
                    text="Postcards Report"
                  />
                  <NavDropdownLink
                    requiredPermission="ALL_STUDENTS_REPORT_VIEW"
                    to="/AllStudentsReport"
                    text="All students"
                  />
                  <NavDropdownLink
                    requiredPermission="CROSS_YEAR_REPORT_VIEW"
                    to="/CrossYearDataReport"
                    text="Cross-Year Data"
                  />
                  <NavDropdownLink
                    requiredPermission="INSTUTIONAL_SELECTED_VERIFICATION_REPORT_VIEW"
                    to="/InstitutionalSelectedVerificationReportPage"
                    text="Institutional Selected for Verification"
                  />
                  <NavDropdown.Divider />
                  <p className="dropdownLabel">Specialty Reports</p>
                  <NavDropdownLink
                    requiredPermission="EDUCATIONAL_PURPOSE_REPORT_VIEW"
                    to="/EducationalPurposeReportPage"
                    text="V4/V5 ID/Educational Purpose"
                  />
                  <NavDropdownLink
                    requiredPermission="INITIAL_COMMUNICATION_TO_VERIFIED_REPORT_VIEW"
                    to="/VerificationReport"
                    text="Initial Communication to Verified Report"
                  />
                  <NavDropdownLink
                    requiredPermission="AUTO_VERIFIED_STUDENTS_REPORT_VIEW"
                    to="/AutoVerifyReport"
                    text="Auto Verified Students Report"
                  />
                  <NavDropdownLink
                    requiredPermission="CONFIRMED_CORRECTIONS_AUTO_VERIFIED_STUDENTS_REPORT_VIEW"
                    to="/CorrectionAutoVerifyReport"
                    text="Confirmed Corrections Auto Verified Students Report"
                  />
                  <NavDropdownLink
                    requiredPermission="ACCOUNT_OWNERSHIP_REPORT_VIEW"
                    to="/AccountOwnershipReport"
                    text="Account Ownership Report"
                  />
                  <NavDropdownLink
                    requiredPermission="ACCOUNT_QC_REPORT_VIEW"
                    to="/AccountQCReport"
                    text="Account QC Report"
                  />
                  <NavDropdownLink
                    requiredPermission="NON_MATCHING_SSN_REPORT_VIEW"
                    to="/NonMatchingSSNReport"
                    text="Non-Matching SSN Report"
                  />
                  <NavDropdownLink
                    requiredPermission="CHANGED_VALUE_REPORT_VIEW"
                    to="/ChangeReport"
                    text="Changed Value Report"
                  />
                  <NavDropdownLink
                    requiredPermission="DEPENDENCY_CHANGE_REPORT_VIEW"
                    to="/DependencyChangeReport"
                    text="Dependency Change Report"
                  />
                  <NavDropdownLink
                    requiredPermission="SUPER_BINDER_REPORT_VIEW"
                    to="/SuperBinderReport"
                    text="Super Binder Report"
                  />
                  {parseInt(global.aidYear) >= 2026 && (
                  <NavDropdownLink
                    requiredPermission="COMMENT_CODE_REPORT_VIEW"
                    to="/CommentCodeReport"
                    text="Comment Code Report"
                  />
                  )}
                  <NavDropdown.Divider />
                  <p className="dropdownLabel">Worklists</p>
                  <NavDropdownLink
                    requiredPermission="REVIEW_WORKLIST_VIEW"
                    to="/reviewWorklist"
                    text="Review"
                  />
                  <NavDropdownLink
                    requiredPermission="APPROVED_WORKLIST_VIEW"
                    to="/approvedWorklist"
                    text="Approved"
                  />
                  <NavDropdownLink
                    requiredPermission="APPROVED_WITH_CORRECTIONS_WORKLIST_VIEW"
                    to="/approvedWithCorrectionsWorklist"
                    text="Approved With Corrections"
                  />
                  <NavDropdownLink
                    requiredPermission="APPROVED_WITH_CR_CODES_REPORT_VIEW"
                    to="/approvedWithCRWorklist"
                    text="Approved With CR Codes"
                  />
                  <NavDropdownLink
                    requiredPermission="WATCHLIST_REPORT_VIEW"
                    to="/WatchlistReport"
                    text="Watchlist"
                  />
                </NavDropdown>
              </PermissionComponentCheck>
              <CrossSchoolSearchInput />
            </Nav>
          </Navbar.Collapse>
          <SchoolBadge
            school={school}
            auth={auth}
            global={global}
            updateAidYear={updateAidYear}
            signOut={ssoSignOut}
          />
        </Navbar>
      </div>
    );
  } else {
    return <LoadingComponent></LoadingComponent>;
  }
};

const mapStateToProps = (state) => {
  const studRepoPermission =
    state.school.schoolIsirRecInfo && state.school.schoolIsirRecInfo.studRepo
      ? state.school.schoolIsirRecInfo.studRepo
      : false;
  return {
    auth: state.auth,
    global: state.global,
    school: state.school,
    hasStudentRepo: studRepoPermission,
  };
};

export default connect(mapStateToProps, {
  updateAidYear,
  ssoSignOut,
  getSchoolLogo,
  getUser,
  fetchSchoolIsirRecInfo,
})(AdminHeader);
